import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const Forgot = () => {

    const [forgotten, setForgotten] = useState(false)
    const [forgot, setForgot] = useState({ email: '', error: '' })
    const [formerror, setFormError] = useState('')

    const handleChnage = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setForgot(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const removeError = (e) => {
        setFormError('')
    }

    const getForgot = async (e) => {
        e.preventDefault();
        if (forgot.email !== '') {
            await axios.post(
                localStorage.getItem('basurl') + '/forgot', forgot,
            ).then(response => {
                setForgotten(true)
            }).catch(error => {
                if (error.response) {
                    setFormError(error.response.data.message)
                } else if (error.message) {
                    setFormError(error.message)
                } else {
                    setFormError('Oops! There are some error in this process. Please try after some time.')
                }
            });
        } else {
            setFormError('Please enter required details')
        }
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-center bg-br-primary ht-100v">
                <div className="login-wrapper wd-300 wd-xs-350 pd-25 pd-xs-40 bg-white rounded shadow-base">
                    <div className="signin-logo tx-center tx-28 tx-bold tx-inverse"><span className="tx-normal">[TV9 MOJO]</span></div>
                    <div className="tx-center mg-b-35">Mobile Friendly Solution</div>
                    {forgotten ?
                        <>
                            <p className="tx-bold tx-14">
                                Reset password link has been mailed to your registered email address.
                            </p>
                            <br />
                            <NavLink to="/login">Go Back</NavLink>
                        </> :
                        <>
                            <p>Forgot Password?</p>
                            <span className="text-danger">{formerror}</span>
                            <form method="get" className="text-left form-validate" onSubmit={getForgot}>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-email tx-16 lh-0 op-6"></i></span>
                                    <input name="email" type="text" className="form-control" placeholder="Enter email/phone" onFocus={removeError} onChange={handleChnage} value={forgot.email} />
                                </div>
                                <div className="form-group">
                                    <NavLink className="tx-info tx-16" to="/login">Go Back</NavLink>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="submit" className="btn btn-primary pull-right">Reset</button>
                                </div>
                            </form>
                        </>
                    }
                </div>
            </div>
        </>
    )
}
export default Forgot;